import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { initialVideoFolderState } from '..';
import { clearDeleteProject, deleteProjectAsync } from '../../actions';
import { removeProject, removeProjectFromFolderTree } from '../../helpers';
import { VideoFolderActions } from '../../types';

const deleteProjectReducer: Reducer<typeof initialVideoFolderState, VideoFolderActions> = (
  state = initialVideoFolderState,
  action
) => {
  switch (action.type) {
    case getType(clearDeleteProject): {
      return {
        ...state,
        deleteProject: initialVideoFolderState.deleteProject
      };
    }
    case getType(deleteProjectAsync.request): {
      const { projectId } = action.payload;
      return {
        ...state,
        deleteProject: {
          ...state.deleteProject,
          error: null,
          projectId,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(deleteProjectAsync.success): {
      const { projectId } = state.deleteProject;
      const { id: currentFolderId } = state.data!;

      return {
        ...state,
        data: removeProject(state.data!, projectId!),
        folderTree: removeProjectFromFolderTree({ state, currentFolderId }),
        deleteProject: {
          ...state.deleteProject,
          isPending: false
        }
      };
    }
    case getType(deleteProjectAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        deleteProject: {
          ...state.deleteProject,
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default deleteProjectReducer;
